export const REGULAR_SEASON_WEEKS = 18;
export const WEEK_WINDOW_SIZE = 6;

export function parseWeekNumber(weekKey: string): number {
  const m = /-W(\d+)$/.exec(weekKey);
  return m ? Number(m[1]) : 1;
}

export function parseWeekYear(weekKey: string): number {
  const m = /^(\d+)-W/.exec(weekKey);
  return m ? Number(m[1]) : 2026;
}

/** Live week plus the next five, stopping at the last regular-season week. */
export function weekWindow(
  liveWeek: number,
  size = WEEK_WINDOW_SIZE,
  last = REGULAR_SEASON_WEEKS,
): number[] {
  const start = Math.max(1, liveWeek);
  const end = Math.min(last, start + size - 1);
  const weeks: number[] = [];
  for (let n = start; n <= end; n++) weeks.push(n);
  return weeks;
}
